'use strict';
var inputs = document.querySelectorAll('form input');
inputs.forEach(function(input) {
    var label = document.createElement('label');
    label.classList.add('field-label');
    label.setAttribute('for', input.id);
    var text = input.name[0].toUpperCase() + input.name.slice(1);
    label.textContent = text;
    input.placeholder = text;
    input.parentElement.prepend(label);
});

//# sourceMappingURL=js_task_fix_form_DOM.27c16852.js.map
